import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/alert-endpoints",
    name: "Alert Endpoint Manager",
    component: () => import("./alertEndpointManager.vue"),
  },
  {
    path: "/brand-manager",
    name: "Brand Manager",
    component: () => import("./brandManager.vue"),
  },
  {
    path: "/cache-manager",
    name: "Cache Manager",
    component: () => import("./cacheManager.vue"),
  },
  {
    path: "/component-playground",
    name: "Dev Playground",
    component: () => import("./componentPlayground.vue"),
  },
  {
    path: "/host-access-admin",
    name: "Host Access Admin",
    component: () => import("./hostAccessAdmin.vue"),
  },
  {
    path: "/hosted-apps",
    name: "S1 Hosted Apps",
    component: () => import("./hostedAppListing.vue"),
  },
  {
    path: "/secrets-management",
    name: "Secrets Management",
    component: () => import("./secretsManagement.vue"),
  },
  {
    path: "/site-maintenance",
    name: "Site Maintenance",
    component: () => import("./siteMaintenance.vue"),
  },
  {
    path: "/manage-user-rights",
    name: "User Rights Management",
    component: () => import("./userRights.vue"),
  },
] satisfies RouteRecordRaw[];
